import { Environment, Language } from "@mrdm-self-service-frontend/shared/assets";

import { Auth0Config } from "./auth0";
import { IMatomo } from "./matomo";
import { IUserflowConfiguration } from "./userflow";
import { FeatureFlags } from "./feature-flags";
import { AppLinks } from "./links";

export interface AppSettings {
    instance: string;
    environment: Environment;
    version: string;
    api: {
        applicationUrl: string;
        authorizationUrl: string;
    };
    links?: AppLinks;
    localization?: {
        defaultLanguage?: Language;
        availableLanguages?: Language[];
    };
    auth0: Auth0Config;
    matomo: IMatomo;
    userflow?: IUserflowConfiguration;
    featureFlags?: FeatureFlags;
}
